module.exports = __webpack_public_path__ + "static/media/YM17_5.abc7a971.jpg";